import { render, staticRenderFns } from "./koditem3.vue?vue&type=template&id=7e44caae&scoped=true"
import script from "./koditem3.vue?vue&type=script&lang=js"
export * from "./koditem3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e44caae",
  null
  
)

export default component.exports